module.exports = __webpack_public_path__ + "img/error.bdb6cce6.svg";